import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect
} from "react";
import "../ficha-master.css";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from "sweetalert2";
import FormInput from "../../../../nuup/componentes/Forms/FormInput.jsx";
import Api from "../../../../api/global.service.js";
import BlockUi from 'react-block-ui';
import FichaCoopPreguntasConversion from "../components/ficha-coop-preguntas-conversion.jsx";

const ModalFichaMasterActualizaDatos = forwardRef((props, ref) => {
  const [show, setShow] = useState(false);
  const [blocking, setBlocking] = useState(false);
  const [error, setError] = useState("");
  const [idFicha, setIdFicha] = useState(0);
  const [ficha, setFicha] = useState({});
  const [fichaMaster, setFichaMaster] = useState();
  const [preguntasSeleccionadas, setPreguntasSeleccionadas] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
    clearErrors,
  } = useForm({
    resolver: async (data, context, options) => {
      return yupResolver(schema)(data, context, options);
    },
    mode: "onBlur",
    defaultValues: {
      nombre: "",
      descripcion: "",
    },
  });

  const schema = yup.object().shape({
    nombre: yup.string().required("El nombre es requerido"),
    descripcion: yup.string().required("La descripción es requerida"),
  });

  //To call outside
  useImperativeHandle(ref, () => ({
    show: showHandler,
    setData: (data) => setFicha(data),
    setDataMaster: (data) => setFichaMaster(data)
  }));

  const showHandler = () => {
    setShow(true);
  };

  const closeHandler = () => {
    props.onFinish();
    setShow(false);
  };

  const setId = (id) => {
    setIdFicha(id);
  };

  const onSubmit = async (values) => {
    try {
      setBlocking(true);

      Api.update("ficha/kobo/master/actualizadatos", ficha.id_kobo_ficha_principal,{
        nombre: values.nombre,
        descripcion: values.descripcion,
        preguntasSeleccionadas: preguntasSeleccionadas,
      })
      .then((response) => {
        setBlocking(false);
        closeHandler();
      })
      .catch((e) => {
        setBlocking(false);
      });

    } catch (e) {
      setBlocking(false);
      await Swal.fire({
        icon: "error",
        title: "",
        text: e.response.data.message,
      });
    }
  };

  useEffect(() => {
    if(ficha?.id_kobo_ficha_principal > 0){
      setBlocking(true);
      Api.get("ficha/kobo/master/detalles", ficha?.id_kobo_ficha_principal)
        .then((response) => {
          setValue('nombre',response.data.nombre);
          setValue('descripcion',response.data.descripcion);
          setBlocking(false);
        })
        .catch((e) => {
          setBlocking(false);
        });
    }
  }, [ficha?.id_kobo_ficha_principal]);

  return (
    <div
      className="modal"
      style={{
        display: show ? "block" : "none",
        backgroundColor: "rgba(0,0,0,0.2)",
      }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg modal-ficha-master__dialog">
        <div className="modal-content" 
             style={{ height: "100%" }}>
          <div className="modal-header" 
               style={{ flex: "inherit" }}>
            <h4 style={{color : 'black'}}>{ficha?.nombre}</h4>
            <button
              onClick={() => closeHandler()}
              type="button"
              className="btn"
              style={{ borderRadius: "20px 20px 20px 20px" }}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
          <div className="modal-body">
            <BlockUi tag="div" message="" blocking={blocking} 
                     renderChildren={true}>
              <p style={{ backgroundColor: "gray", padding: 5, color: "white" }}>
                1. Información general
              </p>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="m-b-15">
                  <FormInput
                    id="nombre"
                    type="text"
                    name="nombre"
                    label=""
                    placeholder="Nombre"
                    error={errors.nombre}
                    register={register}
                  />
                </div>

                <div className="m-b-15">
                  <FormInput
                    id="descripcion"
                    type="text"
                    name="descripcion"
                    label=""
                    placeholder="descripcion"
                    error={errors.descripcion}
                    register={register}
                  />
                </div>
                {/*<p style={{ backgroundColor: "gray", padding: 5, color: "white" }}>
                  2. Conversión de variables
                </p>
                <FichaCoopPreguntasConversion fichaMaster={fichaMaster}  
                     onChange={(items) => setPreguntasSeleccionadas(items)}/>
                */}
                <div className="form-group m-b-15">
                  <span style={{ color: "red" }}>{error}</span>
                </div>
                {!blocking && (
                  <button
                    type="submit"
                    className="btn btn-sirio"
                    style={{ borderRadius: "20px 20px 20px 20px" }}
                  >
                    <i className="fa fa-save"></i> Guardar
                  </button>
                )}
              </form>
            </BlockUi>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ModalFichaMasterActualizaDatos;
